// Topics
export const SELECT_TOPIC = 'SELECT_TOPIC';
export const FETCHED_TOPIC = 'FETCHED_TOPIC';
export const FETCHING_TOPIC = 'FETCHING_TOPIC';
export const FETCHED_TOPICS = 'FETCHED_TOPICS';
export const FETCHING_TOPICS = 'FETCHING_TOPICS';
export const RESETING_TOPICS = 'RESETING_TOPICS';

export const UPDATE_APPROVAL_ID = 'UPDATE_APPROVAL_ID';

export const FETCHING_TOPIC_MEMBERS = 'FETCHING_TOPIC_MEMBERS';
export const FETCHED_TOPIC_MEMBERS = 'FETCHED_TOPIC_MEMBERS';
export const RESETING_TOPIC_MEMBERS = 'RESETING_TOPIC_MEMBERS';

// Posts
export const INIT_POSTS = 'INIT_POSTS';
export const FETCHED_POSTS = 'FETCHED_POSTS';
export const FETCHING_POSTS = 'FETCHING_POSTS';
export const RESET_POSTS = 'RESET_POSTS';

export const FETCHED_PINNED_ITEMS = 'FETCHED_PINNED_ITEMS';
export const FETCHING_PINNED_ITEMS = 'FETCHING_PINNED_ITEMS';

export const CREATED_DRAFT_POST = 'CREATED_DRAFT_POST';
export const SUBMITTING_POST = 'SUBMITTING_POST';
export const SUBMITTED_POST = 'SUBMITTED_POST';
export const UPDATING_POST = 'UPDATING_POST';
export const UPDATED_POST = 'UPDATED_POST';
export const DELETING_POST = 'DELETING_POST';
export const DELETED_POST = 'DELETED_POST';

// Tags
export const UPDATE_SELECTED_TAGS = 'UPDATE_SELECTED_TAGS';

export const FOLLOWED_TOPIC = 'FOLLOWED_TOPIC';
export const UNFOLLOWED_TOPIC = 'UNFOLLOWED_TOPIC';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export const FETCHING_FOLLOWINGS = 'FETCHING_FOLLOWINGS';
export const FETCHED_FOLLOWINGS = 'FETCHED_FOLLOWINGS';
